import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { getDepreciationAssetCount, getPuttodateTagsList } from '../../services/asset.service';
import * as CryptoJS from "crypto-js";
import '../ExcelUploads/AssetInfo/AssetInfo.css';
import FromMoveListIT from "../../molecules/FromMoveListIT";
import FromMoveListESD from "../../molecules/FromMoveListESD";

export default function GenerateITDepreciationCont() {
    const [financeInfo, setFinanceInfo] = useState({});
    const [back_url, setBackUrl] = useState('');

    const [loadingIT, setLoadingIT] = useState(false);
    const [progress, setProgress] = useState(0);
    const [total, setTotal] = useState(0);

    const [assetPopDisplayIT, setAssetPopDisplayIT] = useState(false);
    const [assetsDataIT, setAssetsDataIT] = useState([]);

    const [assetPopDisplayESD, setAssetPopDisplayESD] = useState(false);
    const [assetsDataESD, setAssetsDataESD] = useState([]);

    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const Finance = query.get('finance');

    useEffect(() => {
        if (Finance) {
            try {
                const decryptedBytes = CryptoJS.AES.decrypt(
                    Finance.replace(/ /g, '+'),
                    process.env.REACT_APP_ENCRYPT_SECRET_KEY
                );
                const decrypt_data = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
                setFinanceInfo(decrypt_data);
                setBackUrl(decrypt_data?.back_url || '/it-master/generate-depreciation');
            } catch (e) {
                console.error("Decryption failed");
            }
        }
    }, [Finance]);

    useEffect(() => {
        if (financeInfo?.finance_year) {
            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: { year: financeInfo.finance_year },
                    authToken: sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const oData = { token: EncryptData };

            getPuttodateTagsList(oData).then((res) => {
                if (res?.data?.data) {
                    setAssetsDataIT(res.data.data);
                    setAssetsDataESD(res.data.data);
                }
            });

            getDepreciationAssetCount(oData).then((res) => {
                if (res?.data?.total_dep_as) {
                    setAssetsDataIT(res.data.total_dep_as);
                    setAssetsDataESD(res.data.total_dep_as);
                }
            });
        }
    }, [financeInfo]);

    const percentage = total > 0 ? Math.round((progress / total) * 100) : 0;

    return (
        <div className='container-fluid' style={{ backgroundColor: '#f5f7fa', minHeight: '100vh', padding: '30px' }}>

            {loadingIT && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.75)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        padding: '50px',
                        borderRadius: '16px',
                        textAlign: 'center',
                        minWidth: '450px',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
                        animation: 'fadeIn 0.3s ease-in'
                    }}>
                        <div className="spinner-border text-primary" role="status" style={{
                            width: '4rem',
                            height: '4rem',
                            marginBottom: '25px',
                            borderWidth: '4px'
                        }}>
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <h4 style={{ marginBottom: '15px', color: '#2c3e50', fontWeight: '600' }}>
                            <i className="bi bi-gear-fill" style={{ marginRight: '10px', color: '#007bff' }}></i>
                            Generating IT Depreciation for {financeInfo.finance_year_name}
                        </h4>
                        <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#007bff', marginBottom: '20px' }}>
                            {progress} of {total} Assets Generated
                        </p>
                        <div style={{
                            width: '100%',
                            height: '35px',
                            backgroundColor: '#e9ecef',
                            borderRadius: '20px',
                            overflow: 'hidden',
                            marginBottom: '20px',
                            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                            <div style={{
                                width: `${percentage}%`,
                                height: '100%',
                                background: 'linear-gradient(90deg, #007bff 0%, #0056b3 100%)',
                                transition: 'width 0.3s ease',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '15px',
                                boxShadow: '0 2px 4px rgba(0, 123, 255, 0.4)'
                            }}>
                                {percentage}%
                            </div>
                        </div>
                        <div style={{
                            padding: '12px',
                            backgroundColor: '#e7f3ff',
                            borderRadius: '8px',
                            border: '1px solid #b3d9ff'
                        }}>
                            <p style={{ fontSize: '14px', color: '#0056b3', margin: 0, fontWeight: '500' }}>
                                <i className="bi bi-info-circle-fill" style={{ marginRight: '6px' }}></i>
                                Please don't refresh the page until the process is completed
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {/* Header Section - Enhanced */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '15px 20px',
                marginBottom: '30px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                border: '1px solid #e9ecef'
            }}>
                <div className='row align-items-center'>
                    <div className="col-lg-5 col-md-12 mb-3 mb-lg-0">
                        <h3 style={{
                            margin: 0,
                            fontSize: '1.45rem',
                            fontWeight: '700',
                            color: '#2c3e50',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px'
                        }}>
                            <i className="bi bi-calculator-fill" style={{ color: '#007bff' }}></i>
                            Generate IT Depreciation
                        </h3>
                    </div>

                    <div className="col-lg-3 col-md-6 mb-3 mb-lg-0">
                        <div style={{
                            padding: '12px 20px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '8px',
                            border: '2px solid #e9ecef'
                        }}>
                            <div style={{ fontSize: '16px', fontWeight: '700', color: '#2c3e50' }}>
                                {financeInfo.finance_year_name}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-12 text-lg-end">
                        <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                            <a href={back_url} className='btn btn-outline-secondary' style={{
                                borderRadius: '8px',
                                padding: '10px 20px',
                                fontWeight: '500',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="bi bi-arrow-left"></i> Back
                            </a>
                            <a className='btn btn-outline-primary' href='' style={{
                                borderRadius: '8px',
                                padding: '10px 20px',
                                fontWeight: '500',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px'
                            }}>
                                <i className="bi bi-arrow-clockwise"></i> Refresh
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Depreciation Cards Section */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '30px',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                border: '1px solid #e9ecef'
            }}>
                {/* Table Header */}
                <div className="row" style={{
                    padding: '15px 20px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    marginBottom: '20px',
                    fontWeight: '600',
                    color: '#495057',
                    border: '1px solid #dee2e6'
                }}>
                    <div className="col-lg-6 col-md-5">
                        <i className="bi bi-card-list"></i> PARTICULARS
                    </div>
                    <div className="col-lg-3 col-md-3">
                        <i className="bi bi-activity"></i> STATUS
                    </div>
                    <div className="col-lg-3 col-md-4">
                        <i className="bi bi-lightning-fill"></i> ACTION
                    </div>
                </div>

                {/* Depreciation Row: Normal IT Depreciation */}
                <div className="row align-items-center" style={{
                    padding: '20px',
                    backgroundColor: '#ffffff',
                    borderRadius: '10px',
                    border: '1px solid #e9ecef',
                    marginBottom: '15px'
                }}>
                    <div className="col-lg-6 col-md-5">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#e7f3ff',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <i className="bi bi-calculator" style={{ color: '#007bff', fontSize: '20px' }}></i>
                            </div>
                            <div>
                                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                                    Normal Income Tax Depreciation
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-3">
                        <span style={{
                            padding: '6px 16px',
                            backgroundColor: '#fff3cd',
                            color: '#856404',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600'
                        }}>
                            <i className="bi bi-clock-history me-1"></i> Not generated
                        </span>
                    </div>

                    <div className="col-lg-3 col-md-4">
                        <FromMoveListIT
                            labelIT="Normal Income Tax Depreciation"
                            showPopUpIT={assetPopDisplayIT}
                            setShowPopUpIT={setAssetPopDisplayIT}
                            dataIT={assetsDataIT}
                            datasetterIT={setAssetsDataIT}
                            setLoadingIT={setLoadingIT}
                            setProgress={setProgress}
                            setTotal={setTotal}
                        />
                    </div>
                </div>

                {/*ESD - Double and Triple Shift Depreciation*/}
                <div className="row align-items-center" style={{
                    padding: '20px',
                    backgroundColor: '#ffffff',
                    borderRadius: '10px',
                    border: '1px solid #e9ecef',
                    marginBottom: '15px'
                }}>
                    <div className="col-lg-6 col-md-5">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <div style={{
                                width: '40px',
                                height: '40px',
                                backgroundColor: '#e7f3ff',
                                borderRadius: '8px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <i className="bi bi-calculator" style={{ color: '#007bff', fontSize: '20px' }}></i>
                            </div>
                            <div>
                                <div style={{ fontWeight: '600', color: '#2c3e50', fontSize: '15px' }}>
                                    ESD - Double and Triple Shift Depreciation
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-3">
                        <span style={{
                            padding: '6px 16px',
                            backgroundColor: '#fff3cd',
                            color: '#856404',
                            borderRadius: '20px',
                            fontSize: '13px',
                            fontWeight: '600'
                        }}>
                            <i className="bi bi-clock-history me-1"></i> Not generated
                        </span>
                    </div>

                    <div className="col-lg-3 col-md-4">

                        <FromMoveListESD
                            labelIT="ESD-Double and Triple Shift Depreciation"
                            showPopUpIT={assetPopDisplayIT}
                            setShowPopUpIT={setAssetPopDisplayIT}
                            dataIT={assetsDataIT}
                            datasetterIT={setAssetsDataIT}
                            setLoadingIT={setLoadingIT}
                            setProgress={setProgress}
                            setTotal={setTotal}
                        />
                    </div>
                </div>

            </div>

            {/* Optional: Info Footer */}
            <div style={{
                marginTop: '25px',
                padding: '20px',
                backgroundColor: '#e7f3ff',
                borderRadius: '10px',
                border: '1px solid #b3d9ff',
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
            }}>
                <i className="bi bi-info-circle-fill" style={{ fontSize: '24px', color: '#0056b3' }}></i>
                <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: '600', color: '#004085', marginBottom: '4px' }}>
                        Important Information
                    </div>
                    <div style={{ fontSize: '14px', color: '#004085' }}>
                        Select the depreciation type and click "Continue" to process assets. The system will
                        automatically calculate depreciation based on your selection.
                    </div>
                </div>
            </div>
        </div>
    );
}